// import {useState, useEffect} from "react";
import {Navigate} from "react-router-dom";
import DoctorDashboard from "./DoctorDashboard";
import PatientDashboard from "./PatientDashboard";
import AdminDashboard from "./AdminDashboard";

const DashboardPage = ({mainUser}) => {
    /*const [loggedUser, setLoggedUser] = useState({token: "", message: "", state: "", userNameFamily: "", userMode: ""});
    const currentLoggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (currentLoggedUser != null && currentLoggedUser.state === "success" && currentLoggedUser.token !== loggedUser.token) {
        setLoggedUser({
            state: currentLoggedUser.state,
            token: currentLoggedUser.token,
            message: currentLoggedUser.message,
            userMode: currentLoggedUser.user_mode,
            userNameFamily: currentLoggedUser.user_name_family
        });
    }*/
  /*  useEffect(() => {
        setLoggedUser(mainUser);
    }, [mainUser, loggedUser]);*/

    switch (mainUser.userMode) {
        case "doctor": {
            return (
                <DoctorDashboard/>
            )
        }
        case "patient": {
            return (
                <PatientDashboard/>
            )
        }
        case "admin": {
            return (
                <AdminDashboard/>
            )
        }
        default: {
            return (<Navigate to="/login"/>)
        }
    }

}

export default DashboardPage;